<template>
  <div class="payPage">
    <div class="pay">
      <el-row class="centerIE">
        <el-col :span="4"><i class="el-icon-circle-check"></i></el-col>
      </el-row>
      <el-row>
        <el-col><p>缴费成功,正在为您安排考场请耐心等待</p></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import '../assets/style/mixin.scss';
.payPage {
  .pay {
    color: #67c23a;
    i {
      font-size: 80px;
      margin-top: 50px;
      margin-bottom: 18px;
    }
    p {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 28px;
      line-height: 50px;
    }
    .el-button {
      margin-left: 20px;
    }
  }
  @include autoInner;
}
// icon居中
.centerIE {
  transform: translate(45%);
}
</style>
